<template>
  <div id="wrap">
    <Header></Header>
    <div class="content_box">
      <main id="wrapMain">
        <Left v-show="isShowLeft"></Left>
        <Right v-if="isShowLeft"></Right>
        <iframe v-if="!isShowLeft && isShow" :src="this.iframe"></iframe>
      </main>
      <div id="frame" v-if="this.isShowIframe">
        <div class="top">
          <div class="right">
            <span style="float: left; margin-top: 5px">布局：</span>
            <el-radio-group
              @change="layout"
              style="float: left"
              v-model="fontSize"
            >
              <el-radio-button label="上下"></el-radio-button>
              <el-radio-button label="左右"></el-radio-button>
            </el-radio-group>
            <span style="float: left; margin-top: 5px; margin-left: 10px"
              >分屏：</span
            >
            <el-radio-group
              @change="splited"
              style="float: left"
              v-model="split"
            >
              <el-radio-button label="3:1"></el-radio-button>
              <el-radio-button label="2:1"></el-radio-button>
              <el-radio-button label="1:1"></el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <!--          <iframe  :src="this.iframe">-->

        <!--          </iframe>-->
        <div
          class="ql-editor"
          v-html="questionData.questionDto.questionContent"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { moduleId } from "../../../../../store/modules/exam";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Header from "../testSumulationComponentNew/header";
import Right from "../testSumulationComponentNew/ExamRight";
import Left from "../testSumulationComponentNew/examLeft";
export default {
  name: "testSumulation",
  data() {
    return {
      iframe: null,
      isShowDia: false,
      countDown: 5,
      fontSize: "左右",
      split: "2:1",
      spliteType: true,
      isShow: false,
    };
  },
  computed: {
    ...mapState(moduleId, {
      isShowIframe: (state) => state.isShowIframe,
      iframeUrl: (state) => state.iframeUrl,
      sign: (state) => state.sign,
      paperData: (state) => state.paperData,
      questionData: (state) => state.questionData,
      isShowLeft: (state) => state.isShowLeft,
    }),
  },
  components: {
    Header: Header,
    Left: Left,
    Right: Right,
  },
  watch: {
    isShowIframe(val) {
      if (val) {
        this.fontSize = "左右";
        this.spliteType = true;
        this.split = "3:1";
      }
    },
    iframeUrl(newVal) {
      this.isShow = false;
      let token = localStorage.getItem("Authorization");
      if (newVal.type === "fz") {
        this.iframe =
          newVal.url +
          `token=${token}&paperId=${this.$route.query.paperId}&questionId=${this.questionData.questionId}&courseId=${this.$route.query.id}&classId=${this.$route.query.classId}`;
      } else if (newVal.type === "stx") {
        this.iframe = newVal.url;
      }
      this.$nextTick(() => {
        this.isShow = true;
      });
      console.log("-testSumulation.vue--89行-iframe：", this.iframe);
    },
  },
  methods: {
    ...mapMutations(moduleId, ["SHOW_LEFT"]),
    layout(val) {
      if (val === "上下") {
        $(".content_box").css("flex-direction", "column");
        $("#wrapMain").css({
          height: "75%",
          width: "100%",
        });
        $("#frame").css("width", "100%");
        $("#frame").css("height", "25%");
        this.spliteType = false;
        this.split = "3:1";
      } else if (val === "左右") {
        this.spliteType = true;
        this.split = "3:1";
        $(".content_box").css("flex-direction", "row");
        $("#wrapMain").css("height", "100%");
        $("#wrapMain").css("width", "75%");
        $("#frame").css("width", "25%");
        $("#frame").css("height", "100%");
      }
    },
    splited(val) {
      if (this.spliteType === false) {
        $("#wrapMain").css("width", "100%");
        $("#frame").css("width", "100%");
        if (val === "3:1") {
          $("#wrapMain").css("height", "75%");
          $("#frame").css("height", "25%");
        } else if (val === "2:1") {
          $("#wrapMain").css("height", "65%");
          $("#frame").css("height", "35%");
        } else if (val === "1:1") {
          $("#wrapMain").css("height", "50%");
          $("#frame").css("height", "50%");
        }
      } else {
        if (val === "3:1") {
          $("#wrapMain").css("width", "75%");
          $("#frame").css("width", "25%");
        } else if (val === "2:1") {
          $("#wrapMain").css("width", "65%");
          $("#frame").css("width", "35%");
        } else if (val === "1:1") {
          $("#wrapMain").css("width", "50%");
          $("#frame").css("width", "50%");
        }
      }
    },
  },
  mounted() {
    $(".study_header").hide();
    $(".switch_wrap main").css("height", "100%");
    window.addEventListener("onbeforeunload", function () {
      alert("确定关闭页面");
    });
  },
};
</script>

<style lang="scss" scoped>
#wrap {
  width: 100%;
  height: 100%;
  .content_box {
    width: 100%;
    height: calc(100% - 60px);
    display: flex;
    flex-direction: column;
    main {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      position: relative;
      transition: all 1s;
      iframe {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: auto;
      }
      .foot {
        position: absolute;
        left: 45%;
        bottom: -12px;
        display: flex;
        flex-direction: row;
        .pre_btn {
          width: 65px;
          height: 20px;
          border-radius: 3px;
          display: block;
          background: rgba(83, 151, 247, 1);
          opacity: 0.5;
          cursor: pointer;
          text-align: center;
          line-height: 20px;
          font-size: 15px;
          &:hover {
            opacity: 1;
          }
          i {
            color: white;
          }
        }
        .btn {
          width: 65px;
          height: 20px;
          border-radius: 3px;
          display: block;
          background: rgba(83, 151, 247, 1);
          opacity: 0.5;
          cursor: pointer;
          text-align: center;
          line-height: 20px;
          margin-left: 20px;
          color: white;
          &:hover {
            opacity: 1;
          }
          i {
            color: white;
          }
        }

        .next_btn {
          width: 65px;
          height: 20px;
          border-radius: 3px;
          font-size: 15px;
          display: block;
          background: rgba(83, 151, 247, 1);
          opacity: 0.5;
          cursor: pointer;
          text-align: center;
          line-height: 20px;
          margin-left: 20px;
          &:hover {
            opacity: 1;
          }
          i {
            color: white;
          }
        }
      }
      .foot_left {
        position: absolute;
        top: 45%;
        right: 0;
        display: flex;
        flex-direction: column;
        .pre_btn {
          width: 17px;
          height: 50px;
          line-height: 50px;
          border-radius: 3px;
          display: block;
          background: rgba(83, 151, 247, 1);
          opacity: 0.5;
          cursor: pointer;
          text-align: center;
          font-size: 15px;
          &:hover {
            opacity: 1;
          }
          i {
            color: white;
          }
        }
        .btn {
          width: 17px;
          height: 50px;
          border-radius: 3px;
          display: block;
          background: rgba(83, 151, 247, 1);
          opacity: 0.5;
          cursor: pointer;
          text-align: center;
          line-height: 30px;
          margin-top: 20px;
          p {
            width: 100%;
            height: 15px;
            color: white;
          }
          &:hover {
            opacity: 1;
          }
          i {
            color: white;
          }
        }

        .next_btn {
          width: 17px;
          height: 50px;
          border-radius: 3px;
          font-size: 15px;
          display: block;
          background: rgba(83, 151, 247, 1);
          opacity: 0.5;
          cursor: pointer;
          text-align: center;
          line-height: 50px;
          margin-top: 20px;
          &:hover {
            opacity: 1;
          }
          i {
            color: white;
          }
        }
      }
    }
    #frame {
      width: 100%;
      /*height: 40%;*/
      /*margin-top: 20px;*/
      flex: 1;
      .ql-editor >>> img {
        width: 100%;
      }
      .top {
        width: 100%;
        height: 40px;
        background: rgba(83, 151, 247, 0.1);
        .right {
          position: absolute;
          right: 0;
          padding-top: 10px;
          min-width: 300px;
          /deep/ .el-radio-group {
            height: 24px;
            .el-radio-button__inner {
              padding: 4px 10px;
              font-size: 12px;
            }
          }
        }
      }
      iframe {
        width: 100%;
        height: calc(100% - 40px);
      }
      .ql-editor {
        width: 100%;
        height: calc(100% - 40px);
        overflow-y: auto;
      }
    }

    #dialog {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.4);
      .content {
        width: 550px;
        height: 320px;
        background: white;
        opacity: 1;
        z-index: 99;
        border-radius: 8px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        .top {
          width: 100%;
          height: 40px;
          background: rgba(255, 190, 47, 1);
          opacity: 1;
          border-radius: 8px 8px 0px 0px;
        }
        .main {
          width: 70%;
          margin: 50px auto 0;
          height: 50px;
          i {
            font-size: 40px;
            color: rgba(255, 190, 47, 1);
            float: left;
          }
          span {
            float: left;
            font-size: 14px;
            width: 302px;
            height: 40px;
            display: inline-block;
            line-height: 40px;
            margin-left: 10px;
          }
        }
        h1 {
          font-size: 60px;
          color: rgba(239, 83, 83, 1);
          text-align: center;
        }
        .btn {
          width: 104px;
          height: 34px;
          text-align: center;
          line-height: 34px;
          border: 1px solid rgba(83, 151, 247, 1);
          opacity: 1;
          border-radius: 17px;
          color: rgba(83, 151, 247, 1);
          margin: 25px auto 0;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testing/testSimulationNew.vue